





















import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "EventCancellationModal",
  components: { BaseConfirm, BaseButton },
  props: {
    postId: { type: String },
    isBuyer: { type: Boolean },
    processing: { type: Boolean, default: false },
  },
  data() {
    return {
      showModal: false,
    };
  },
  mounted() {
    this.showModal = true;
  },
  methods: {
    cancelEvent() {
      this.showModal = false;
      this.$emit("cancelEvent", this.postId);
    },
    keepCancelEvent() {
      this.showModal = false;
      this.$emit("keepCancelEvent");
    },
  },
});
